<template>
  <div class="navigation-drawer-footer">
  <div class="columns-container">
    <div
    class="column icon-container"
    title="View outage history"
    v-on:click="showDataModal()">
      <div class="column-row icon-row chart">
          <img class="icon data" src="../../../assets/img/drawer-icon-chart.svg" alt="chart-icon">
      </div>
      <div class="column-row text-row"><span class="text">Data</span></div>
    </div>
    <div
    title="Go to help center"
    class="column icon-container help">
      <div
      class="column-row icon-row"
      v-on:click="showHelpModal()">
        <img class="icon" src="../../../assets/img/drawer-icon-help.svg" alt="help-icon">
      </div>
      <div class="column-row text-row"><span class="text">Help</span></div>
    </div>
    <span class="column icon-container">
      <div class="column-row icon-row">
        <img
        v-if="!isDarkMode"
        title="Select dark mode"
        v-on:click="onDarkModeChangeEventHandler()"
        class="icon" src="../../../assets/img/drawer-icon-dark-mode.svg" alt="dark-mode-icon">
        <img
        v-if="isDarkMode"
        title="Select light mode"
        v-on:click="onDarkModeChangeEventHandler()"
        class="icon" src="../../../assets/img/drawer-icon-light-mode.svg" alt="dark-mode-icon">
      </div>
      <div class="column-row text-row">
        <span v-if="!isDarkMode"><span class="text">Dark</span></span>
        <span v-if="isDarkMode"><span class="text">Light</span></span>
      </div>
    </span>
    <span class="column icon-container login">
      <div class="column-row icon-row">
        <img
        v-if="!user"
        class="icon"
        v-on:click="showLoginModal()"
        title="Log in"
        src="../../../assets/img/drawer-icon-login.svg" alt="login-icon">
        <user-avatar
        v-if="user"
        :user="user"
        :userIsAdmin="userIsAdmin"
        title="User menu"
        :userAvatarClicked="onUserAvatarClicked"></user-avatar>
      </div>
      <div class="column-row text-row">
        <span v-if="!user" class="text">Login</span>
        <span v-if="user" class="text">User</span>
      </div>
    </span>
  </div>
  </div>
</template>

<script>
import UserAvatar from "@/components/shared/user/UserAvatar";

export default {
  name: 'NavigationDrawerFooter',
  components: {UserAvatar},
  methods: {
    onDarkModeChangeEventHandler () {this.toggleDarkMode()}
  },
  props: {
    user: Object,
    username: String,
    userIsAdmin: Boolean,
    isDarkMode: Boolean,
    userMenuVisible: Boolean,
    adminModalVisible: Boolean,
    loginModalVisible: Boolean,
    userProfileModalVisible: Boolean,
    uilityOutagesModalVisible: Boolean,
    dataModalVisible: Boolean,
    forceNewPasswordModalVisible: Boolean,
    showHelpModal: Function,
    showLoginModal: Function,
    toggleDarkMode: Function,
    onUserAvatarClicked: Function,
    showDataModal: Function,
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.navigation-drawer-footer{
  width: 90%;
  margin: 0 auto;
  padding-top: 10px;

  .columns-container{
    display: flex;
    align-items: center;
    justify-content: space-between;

    .column{
      &.icon-container{
        position: relative;
        width: 35px;
        height: 50px;
        margin: 0 auto;

        .column-row{
          &.icon-row{
            position: relative;

            &:hover{
              cursor: pointer;
            }

            &.chart{
              .icon{
                top: 7px;
                position: relative;

                &.data{
                  top: 0;
                }
              }
            }
          }

          &.text-row{
            position: absolute;
            bottom: 0;

            a{
              color: #fff;
            }

            .text{
              display: block;
              width: 30px;
              text-align: center;
              font-size: 10px;
              color: $greyTextTrans65;
            }
          }
        }
      }
    }
  }
}
</style>
